import { render, staticRenderFns } from "./BotWeddingEventForm.vue?vue&type=template&id=1ec1e9dc"
import script from "./BotWeddingEventForm.vue?vue&type=script&lang=ts"
export * from "./BotWeddingEventForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports